import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

import {
  FaChartLine,
  FaHashtag,
  FaPalette,
  FaBullhorn,
  FaLaptopCode,
  FaMailBulk,
} from "react-icons/fa";

const Services = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const services = [
    {
      title: "Social Media Management",
      description:
        "Engage your audience and grow your brand across all major social platforms.",
      icon: <FaHashtag className="service-icon" />,
      color: "#EC4899", // pink
    },
    {
      title: "Graphic Designing",
      description:
        "Tell your brand's story with compelling visuals that convert visitors into customers.",
      icon: <FaPalette className="service-icon" />,
      color: "#8B5CF6", // purple
    },

    {
      title: "Web Design & Development",
      description:
        "Beautiful, functional websites designed to convert and built to perform.",
      icon: <FaLaptopCode className="service-icon" />,
      color: "#10B981", // emerald
    },
    {
      title: "Promotions & Advertising",
      description:
        "Get immediate traffic and leads with our targeted advertising campaigns.",
      icon: <FaBullhorn className="service-icon" />,
      color: "#F59E0B", // amber
    },
    {
      title: "SEO Optimization",
      description:
        "Boost your website's visibility and rank higher on search engines with our expert SEO strategies.",
      icon: <FaChartLine className="service-icon" />,
      color: "#3B82F6", // blue
    },
    {
      title: "Digital Marketing Services",
      description:
        "Comprehensive digital strategies to grow your online presence and customer base.",
      icon: <FaMailBulk className="service-icon" />,
      color: "#EF4444", // red
    },
  ];

  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const item = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 100 },
    },
  };

  return (
    <section id="services" className="services" ref={ref}>
      <div className="container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          Our <span className="text-gradient">Services</span>
        </motion.h2>
        <motion.p
          className="section-subtitle"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Comprehensive digital solutions tailored to your business needs
        </motion.p>

        <motion.div
          className="services-grid"
          variants={container}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="service-card"
              variants={item}
              whileHover={{
                y: -10,
                boxShadow: `0 15px 30px -5px ${service.color}40`,
              }}
              style={{ "--accent-color": service.color }}
            >
              <div className="icon-wrapper">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <div className="service-footer">
                <span className="learn-more">Learn more →</span>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
